import React, { useState, useEffect, useMemo } from 'react';
import { object, func, bool } from 'prop-types';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject, ComparePeriodos } from '../../../utils/helpers';
import { isNull, isValidNumber } from '../../../utils/validator';
import { addDayToDate, getDateToString } from '../../../utils/convert';
import TablaVersionModal from '../TablaVersionModal';


const TablaVersionesGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      disabled: false,
      idTablaDefinicion: 0,
      list: []
  });

  const [editMode, setEditMode] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [removingId, setRemovingId] = useState(null);


  const mount = () => {
    setState(prevState => {
      const list = props.data.list.filter(x => x.state !== 'r').sort(ComparePeriodos);
      return {...prevState,
        idTablaDefinicion: props.data.idTablaDefinicion,
        list: list
      };
    });
  }
  useEffect(mount, [props.data]);

  const esPrimerVersion = useMemo(() => {
    const versionesActivas = state.list.filter(f => f.state !== "r");
    return (editItem !== null && (versionesActivas.length === 0 || versionesActivas[0].id === editItem.id));
  }, [state.list, editItem]);

  const editItemIndex = useMemo(() => {
    return (editItem !== null) ? state.list.findIndex(x => x.id === editItem.id) : -1;
  }, [state.list, editItem]);

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickTablaVersionAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickTablaVersionView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <>
                                  <div onClick={ (event) => handleClickTablaVersionModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  <div onClick={ (event) => handleClickTablaVersionRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Borrar">delete</span>
                                  </div>
                                  </>
                                  )}                                 
                              </div>

  const tableColumns = [
    { Header: 'Número', accessor: 'numero', width: '20%' },
    { Header: 'Descripción', accessor: 'descripcion', width: '44%', },
    { Header: 'Desde', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaDesde', width: '13%' },
    { Header: 'Hasta', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaHasta', width: '13%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
  ]


  //handles
  const handleClickTablaVersionAdd = () => {
    let newVersion = {
      id: -Date.now(),
      idTablaDefinicion: state.idTablaDefinicion,
      numero: '1',
      descripcion: 'Versión inicial',
      fechaDesde: null,
      fechaHasta: null,
      tablaItems: [],
      state: 'a'
    };

    const listVersion = state.list.filter(item => item.state !== "r");
    if (listVersion.length > 0) {
      newVersion = CloneObject(listVersion[listVersion.length - 1]);
      newVersion.id = -Date.now();
      const numeros = listVersion.filter(item => isValidNumber(item.numero)).map(item => parseInt(item.numero));
      newVersion.numero = numeros.length > 0 ? (Math.max(...numeros) + 1).toString() : `${newVersion.numero}'`;
      newVersion.fechaDesde = !isNull(newVersion.fechaHasta) ? addDayToDate(newVersion.fechaHasta, 1) : null;
      newVersion.fechaHasta = null;
      newVersion.descripcion = `${newVersion.descripcion} (${newVersion.numero})`;
      newVersion.state = "a";
      newVersion.tablaItems = newVersion.tablaItems.filter(item => item.state !== "r").map(y => {
          let x = CloneObject(y);
          x.state = "a";
          return x;
      });
    }

    setEditItem(newVersion);
    setEditMode(true);
  }
  const handleClickTablaVersionView = (id) => {
    const editItem = state.list.find(x => x.id === id);
    setEditItem(editItem);
    setEditMode(false);
  }
  const handleClickTablaVersionModify = (id) => {
    const editItem = state.list.find(x => x.id === id);
    setEditItem(editItem);
    setEditMode(true);
  }
  const handleClickTablaVersionRemove = (id) => {
      setRemovingId(id);
  }

  //funciones
  function confirmRemoveId(id) {
    const row = CloneObject(state.list.find(x => x.id === id));
    row.state = 'r';
    props.onChange('TablaVersion', row);
  }
  function updateTablaVersion(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('TablaVersion', row);
  }

  return (
  <>
    <TableCustom
        showFilterGlobal={false}
        showDownloadCSV={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

    {editItem && 
      <TablaVersionModal
          disabled={!editMode}
          data={{
            entity: editItem,
            columnas: props.data.columnas,
            resultado: props.data.resultado,
            esPrimerVersion: esPrimerVersion
          }}
          onDismiss={() => {
            setEditItem(null)
          }}
          onConfirm={(row) => {
            updateTablaVersion(row)
            setEditItem(null)
          }}
          onMovePrevious={(editItemIndex > 0) ? () => {
            const previousId = state.list[editItemIndex - 1].id;
            if (editMode)
              handleClickTablaVersionModify(previousId);
            else
              handleClickTablaVersionView(previousId);
          } : null}
          onMoveNext={(editItemIndex !== -1 && editItemIndex < state.list.length - 1) ? () => {
            const nextId = state.list[editItemIndex + 1].id;
            if (editMode)
              handleClickTablaVersionModify(nextId);
            else
              handleClickTablaVersionView(nextId);
          } : null}
      />
    }

    {removingId && 
      <MessageModal
          title={"Confirmación"}
          message={"¿Está seguro de borrar el registro?"}
          onDismiss={() => setRemovingId(null)}
          onConfirm={() => {
            confirmRemoveId(removingId)
            setRemovingId(null)
          }}
      />
    }

  </>
  );
}

TablaVersionesGrid.propTypes = {
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

TablaVersionesGrid.defaultProps = {
  disabled: false
};

export default TablaVersionesGrid;